import {
  HIDE_RESCHEDULE_MODAL,
  HIDE_RESERVATION_MODAL,
  RECEIVE_APPOINTMENT_RESCHEDULE,
  RECEIVE_APPOINTMENT_RESCHEDULE_OPTIONS,
  RECEIVE_APPOINTMENT_RESERVATION,
  RECEIVE_APPOINTMENT_RESERVATION_CLINICS,
  RECEIVE_APPOINTMENTS,
  RECEIVE_QUEUE_APPOINTMENTS,
  RECEIVE_APPOINTMENT_DATA,
  REQUEST_APPOINTMENT_DATA,
  REQUEST_APPOINTMENT_DATA_FAILED,
  RECEIVE_AVAILABLE_SLOTS,
  REQUEST_AVAILABLE_SLOTS,
  REQUEST_AVAILABLE_SLOTS_FAILED,
  RESET_AVAILABLE_SLOTS,
  RECEIVE_TIMES_FOR_CLINIC,
  RELEASE_RESCHEDULE_OPTION,
  REQUEST_APPOINTMENT_RESCHEDULE,
  REQUEST_APPOINTMENT_RESCHEDULE_FAILED,
  REQUEST_APPOINTMENT_RESCHEDULE_OPTIONS,
  REQUEST_APPOINTMENT_RESCHEDULE_OPTIONS_FAILED,
  REQUEST_APPOINTMENT_RESERVATION,
  REQUEST_APPOINTMENT_RESERVATION_CLINICS,
  REQUEST_APPOINTMENT_RESERVATION_CLINICS_FAILED,
  REQUEST_APPOINTMENT_RESERVATION_FAILED,
  REQUEST_APPOINTMENTS,
  REQUEST_APPOINTMENTS_FAILED,
  REQUEST_QUEUE_APPOINTMENTS,
  REQUEST_QUEUE_APPOINTMENTS_FAILED,
  SHOW_QUEUE_RESERVATION_MODAL,
  HIDE_QUEUE_RESERVATION_MODAL,
  SELECT_QUEUE_RESERVATION_OPTION,
  REQUEST_QUEUE_RESERVATION_OPTIONS_FAILED,
  REQUEST_TIMES_FOR_CLINIC,
  REQUEST_TIMES_FOR_CLINIC_FAILED,
  RESET_APPOINTMENT_RESERVATION,
  SELECT_CLINIC,
  SELECT_REASON,
  SELECT_RESCHEDULE_OPTION,
  SET_ORIGINAL_APPOINTMENT,
  SHOW_RESCHEDULE_MODAL,
  SHOW_RESERVATION_MODAL,
  REQUEST_PIN_CODE_VALIDATION,
  RECEIVE_PIN_CODE_VALIDATION,
} from './actions';
import { getTime } from '../../utils/TimeUtils';
import { get } from 'lodash';

const appointmentsInitialState = {
  isFetching: false,
  lastFetch: null,
  data: [],
  error: null,
};

export const appointments = (state = appointmentsInitialState, action) => {
  switch (action.type) {
    case REQUEST_APPOINTMENTS:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case RECEIVE_APPOINTMENTS:
      return {
        ...state,
        isFetching: false,
        lastFetch: getTime(),
        data: action.data,
        error: null,
      };
    case REQUEST_APPOINTMENTS_FAILED:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
};

let queueAppointmentsInitialState = {
  isFetching: false,
  lastFetch: null,
  data: [],
  error: null,
};

export const queueAppointments = (
  state = queueAppointmentsInitialState,
  action
) => {
  let { payload, error } = action;
  switch (action.type) {
    case REQUEST_QUEUE_APPOINTMENTS:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_QUEUE_APPOINTMENTS:
      return {
        ...state,
        isFetching: false,
        lastFetch: getTime(),
        data: payload.data,
      };
    case REQUEST_QUEUE_APPOINTMENTS_FAILED: {
      return {
        ...state,
        isFetching: false,
        error: error,
      };
    }
    default:
      return state;
  }
};

let availableSlotsInitialState = {
  isFetching: false,
  lastFetch: null,
  isReserving: false,
  showModal: false,
  error: null,
  data: [],
  appointmentData: [],
};

export const availableSlots = (state = availableSlotsInitialState, action) => {
  let { payload, error } = action;

  switch (action.type) {
    case REQUEST_AVAILABLE_SLOTS:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_AVAILABLE_SLOTS:
      return {
        ...state,
        isFetching: false,
        lastFetch: getTime(),
        data: payload.data,
      };
    case REQUEST_AVAILABLE_SLOTS_FAILED: {
      return {
        ...state,
        isFetching: false,
        error: error,
      };
    }
    case RESET_AVAILABLE_SLOTS: {
      return {
        ...state,
        error: null,
      };
    }
    case REQUEST_APPOINTMENT_DATA:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_APPOINTMENT_DATA:
      return {
        ...state,
        isFetching: false,
        appointmentData: payload.data,
      };
    case REQUEST_APPOINTMENT_DATA_FAILED: {
      return {
        ...state,
        isFetching: false,
        error: payload.error,
      };
    }
    case REQUEST_APPOINTMENT_RESCHEDULE_OPTIONS:
      return {
        ...state,
        isFetching: true,
        data: [],
        error: null,
      };
    case REQUEST_QUEUE_RESERVATION_OPTIONS_FAILED:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case RECEIVE_APPOINTMENT_RESCHEDULE_OPTIONS:
      return {
        ...state,
        isFetching: false,
        data: action.data,
        error: null,
      };
    case SELECT_QUEUE_RESERVATION_OPTION:
      return {
        ...state,
        data: state.data.map((item) =>
          getTime(item.dateStart).isSame(action.dateStart)
            ? { ...item, selected: true }
            : { ...item, selected: false }
        ),
      };
    case RELEASE_RESCHEDULE_OPTION:
      return {
        ...state,
        data: state.data.map((item) =>
          item.original
            ? { ...item, selected: true }
            : { ...item, selected: false }
        ),
      };
    case SHOW_QUEUE_RESERVATION_MODAL:
      return {
        ...state,
        showModal: true,
      };
    case HIDE_QUEUE_RESERVATION_MODAL:
      return {
        ...state,
        showModal: false,
      };
    case REQUEST_APPOINTMENT_RESCHEDULE:
      return {
        ...state,
        isReserving: true,
      };
    case RECEIVE_APPOINTMENT_RESCHEDULE:
      return {
        ...state,
        isReserving: false,
      };
    case REQUEST_APPOINTMENT_RESCHEDULE_FAILED:
      return {
        ...state,
        isReserving: false,
      };
    default:
      return state;
  }
};

let appointmentReservationOptionsInitialState = {
  selectedClinicKey: null,
  selectedReasonKey: null,
  dueDate: null,
  isFetching: false,
  data: [],
  error: null,
  pinCode: '',
  pinCodeIsValid: false,
  pinCodeError: false,
};
export const appointmentReservationOptions = (
  state = appointmentReservationOptionsInitialState,
  action
) => {
  let { type, payload, meta } = action;
  switch (type) {
    case SELECT_CLINIC:
      return {
        ...state,
        selectedClinicKey: payload.key,
      };
    case SELECT_REASON:
      return {
        ...state,
        selectedReasonKey: payload.key,
        dueDate: payload.dueDate,
      };
    case RESET_APPOINTMENT_RESERVATION:
      return {
        ...state,
        selectedReasonKey: null,
        dueDate: null,
        selectedClinicKey: null,
      };
    case REQUEST_APPOINTMENT_RESERVATION_CLINICS:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_APPOINTMENT_RESERVATION_CLINICS:
      return {
        ...state,
        isFetching: false,
        data: payload.data,
      };
    case REQUEST_APPOINTMENT_RESERVATION_CLINICS_FAILED: {
      return {
        ...state,
        isFetching: false,
        error: payload.error,
      };
    }
    case REQUEST_PIN_CODE_VALIDATION: {
      return {
        ...state,
        pinCode: meta.pinCode,
        pinCodeError: false,
      };
    }
    case RECEIVE_PIN_CODE_VALIDATION: {
      return {
        ...state,
        pinCodeIsValid: payload.isValid,
        pinCodeError: !payload.isValid,
      };
    }
    default: {
      return state;
    }
  }
};

let clinicInformationInitialState = {
  currentClinic: null,
  isReserving: false,
  reservationError: null,
  isFetching: false,
  data: [],
  error: null,
  showModal: false,
};

export const clinicInformation = (
  state = clinicInformationInitialState,
  action
) => {
  let { type, payload } = action;
  switch (type) {
    case REQUEST_TIMES_FOR_CLINIC:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_TIMES_FOR_CLINIC:
      return {
        ...state,
        isFetching: false,
        data: payload.data, //mapClinicTimes(payload.data)
      };
    case REQUEST_TIMES_FOR_CLINIC_FAILED:
      return {
        ...state,
        isFetching: false,
        error: payload.error,
      };
    case SHOW_RESERVATION_MODAL: {
      return {
        ...state,
        showModal: true,
      };
    }
    case HIDE_RESERVATION_MODAL: {
      return {
        ...state,
        showModal: false,
      };
    }
    case REQUEST_APPOINTMENT_RESERVATION: {
      return {
        ...state,
        isReserving: true,
      };
    }
    case RECEIVE_APPOINTMENT_RESERVATION: {
      return {
        ...state,
        isReserving: false,
      };
    }
    case REQUEST_APPOINTMENT_RESERVATION_FAILED: {
      return {
        ...state,
        isReserving: false,
        reservationError: payload.error,
      };
    }
    default: {
      return state;
    }
  }
};

const appointmentRescheduleOptionsInitialState = {
  isFetching: false,
  isRescheduling: false,
  showModal: false,
  error: null,
  data: [],
  originalAppointment: null,
};

export const appointmentRescheduleOptions = (
  state = appointmentRescheduleOptionsInitialState,
  action
) => {
  switch (action.type) {
    case REQUEST_APPOINTMENT_RESCHEDULE_OPTIONS:
      return {
        ...state,
        isFetching: true,
        data: [],
        error: null,
      };
    case SET_ORIGINAL_APPOINTMENT:
      return {
        ...state,
        originalAppointment: action.data,
      };
    case REQUEST_APPOINTMENT_RESCHEDULE_OPTIONS_FAILED:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case RECEIVE_APPOINTMENT_RESCHEDULE_OPTIONS:
      return {
        ...state,
        isFetching: false,
        data: action.data,
        error: null,
      };
    case SELECT_RESCHEDULE_OPTION:
      return {
        ...state,
        data: state.data.map((item) =>
          getTime(item.dateStart).isSame(action.dateStart)
            ? { ...item, selected: true }
            : { ...item, selected: false }
        ),
      };
    case RELEASE_RESCHEDULE_OPTION:
      return {
        ...state,
        data: state.data.map((item) =>
          item.original
            ? { ...item, selected: true }
            : { ...item, selected: false }
        ),
      };
    case SHOW_RESCHEDULE_MODAL:
      return {
        ...state,
        showModal: true,
      };
    case HIDE_RESCHEDULE_MODAL:
      return {
        ...state,
        showModal: false,
      };
    case REQUEST_APPOINTMENT_RESCHEDULE:
      return {
        ...state,
        isRescheduling: true,
      };
    case RECEIVE_APPOINTMENT_RESCHEDULE:
      return {
        ...state,
        isRescheduling: false,
      };
    case REQUEST_APPOINTMENT_RESCHEDULE_FAILED:
      return {
        ...state,
        isRescheduling: false,
      };
    default:
      return state;
  }
};

export const reducer = (state, action) => {
  return {
    ...state,
    appointments: appointments(get(state, 'appointments'), action),
    queueAppointments: queueAppointments(
      get(state, 'queueAppointments'),
      action
    ),
    availableSlots: availableSlots(get(state, 'availableSlots'), action),
    reschedule: appointmentRescheduleOptions(get(state, 'reschedule'), action),
    reservation: {
      clinics: appointmentReservationOptions(
        get(state, 'reservation.clinics'),
        action
      ),
      times: clinicInformation(get(state, 'reservation.times'), action),
    },
  };
};
